module.exports = __webpack_public_path__ + "static/media/Sort-Asc.2c656398.svg";